import React from "react";
import "../CustomCSS/Expertise.css";
import {
  FaLeaf,
  FaChild,
  FaBrain,
  FaEye,
  FaUserMd,
  FaFlask,
  FaHeart,
  FaBaby,
} from "react-icons/fa";

const expertiseData = [
  { icon: <FaLeaf />, title: "Natural Healing", desc: "Holistic methods for internal balance." },
  { icon: <FaChild />, title: "Child Care", desc: "Gentle wellness for kids." },
  { icon: <FaBrain />, title: "Mind & Wellness", desc: "Mental health support." },
  { icon: <FaEye />, title: "Vision Care", desc: "Focused eye treatments." },
  { icon: <FaUserMd />, title: "Surgery Support", desc: "Safe clinical support." },
  { icon: <FaFlask />, title: "Detox Therapy", desc: "Natural toxin elimination." },
  { icon: <FaHeart />, title: "Rejuvenation", desc: "Restore vitality & energy." },
  { icon: <FaBaby />, title: "Fertility Care", desc: "Support for reproductive health." },
];

export default function Expertise() {
  // Duplicate the sequence exactly twice for seamless loop
  const doubled = [...expertiseData, ...expertiseData];

  return (
    <section id="expertise" className="expertise-section" aria-label="Our Expertise">
      <h2 className="expertise-title">Our Expertise</h2>

      <div className="marquee-container" aria-hidden={false}>
        <div className="marquee-inner" role="presentation">
          {doubled.map((item, idx) => {
            // mark the second copy as hidden to assistive tech
            const isDuplicate = idx >= expertiseData.length;
            return (
              <article
                className="expertise-card"
                key={idx}
                aria-hidden={isDuplicate ? "true" : "false"}
              >
                <div className="expertise-icon" aria-hidden="true">{item.icon}</div>
                <h3 className="expertise-title-card">{item.title}</h3>
                <p className="expertise-desc">{item.desc}</p>
              </article>
            );
          })}
        </div>

        <div className="fade-left" aria-hidden="true" />
        <div className="fade-right" aria-hidden="true" />
      </div>
    </section>
  );
}
